import { ReactNode } from 'react';

const ModuleView = ({ className, children }: { className?: string; children: ReactNode }) => {
  return (
    <>
      <div id="moduleView" className={className}>
        {children}
      </div>
    </>
  );
};

export default ModuleView;
